import React, { useState } from 'react';

import { NumberedPagination } from '../common/pagination/NumberedPagination';
import { UserOrdersListItemLoading } from './UserOrdersListItemLoading';
import { UserOrdersListHeader } from './UserOrdersListHeader';
import { ListContainer } from '../common/ui/ListContainer';
import { UserOrdersListItem } from './UserOrdersListItem';
import { EmptyCard } from '../common/ui/EmptyCard';
import { Component } from '../common/ui/Component';

export const UserOrdersList = ({ isLoading, hasData, data, handlers }) => {
    const [showChildRowOrderId, setShowChildRowOrderId] = useState(null);
    const { onRefresh, ...paginationHandlers } = handlers;

    const handleShowChildRow = (order) => {
        setShowChildRowOrderId(showChildRowOrderId !== order.id ? order.id : null);
    };

    if (isLoading) {
        return (
            <ListContainer>
                <UserOrdersListHeader />
                <Component element={UserOrdersListItemLoading} size={5} />
            </ListContainer>
        );
    }

    if (!hasData) {
        return (
            <ListContainer>
                <EmptyCard icon="file-invoice" text="You don't have orders yet" />
            </ListContainer>
        );
    }

    return (
        <ListContainer>
            <UserOrdersListHeader />
            {data.records.map((order) => (
                <UserOrdersListItem
                    row={order}
                    key={order.id}
                    onRefresh={onRefresh}
                    onShowChildRow={handleShowChildRow}
                    showChildRow={order.id === showChildRowOrderId}
                />
            ))}
            <NumberedPagination className="my-3" data={data} {...paginationHandlers} />
        </ListContainer>
    );
};
